export default __webpack_public_path__ + "static/media/roi_renewed.7289cdc2.png";